export default "__VITE_ASSET__B5JRvgD2__"